import "../../../FhValidationMessage.css";
import { openBlock, createBlock, withCtx, createVNode, unref, renderSlot } from "vue";
import FhText from "../../FhText/FhText.mjs";
import FhIcon from "../../FhIcon/FhIcon.mjs";
import alertFilled from "../../../icons/alertFilled.mjs";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _sfc_main = {
  __name: "FhValidationMessage",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(FhText, {
        color: "error-default",
        variant: "body-sm",
        class: "fh-validation-message",
        weight: "medium",
        role: "alert",
        "aria-live": "polite"
      }, {
        default: withCtx(() => [
          createVNode(FhIcon, {
            icon: unref(alertFilled),
            size: "xs"
          }, null, 8, ["icon"]),
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]),
        _: 3
      });
    };
  }
};
const FhValidationMessage = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-6c739709"]]);
export {
  FhValidationMessage as default
};
//# sourceMappingURL=FhValidationMessage.mjs.map
